import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { TransactionRecordDetailsResponseModel } from '../../../api-refactored/transaction/useGetTransactionDetailsListing';
import TransactionDetailsListingTable from './TransactionDetailsListingTable';

const useStyles = makeStyles()((theme) => ({
  outstandingAmountPosition: {
    display: 'flex',
    textAlign: 'justify',
    justifyContent: 'right',
    alignItems: 'flex-end',
  },
  outstandingAmountLabel: {
    marginRight: theme.spacing(3),
    fontWeight: 'bold',
    color: '#094074',
  },
  outstandingAmountValuePosition: {
    paddingRight: theme.spacing(3),
  },
  lastUpdatedOnLabel: {
    fontWeight: 700,
    color: theme.color.text.textTertiary,
    marginRight: theme.spacing(1),
  },
  lastUpdatedOnPosition: {
    fontWeight: 700,
    color: theme.color.text.textTertiary,
    paddingRight: theme.spacing(3),
  },
}));

interface TransactionDetailsProps {
  model: TransactionRecordDetailsResponseModel;
}

export const SetTransactionAmountPrefix = ({ value }: { value: string }) => {
  let currencyValue = '';
  if (value !== '') {
    currencyValue = value.charAt(0) === '-' ? `-$${value.slice(1)}` : `$${value}`;
  }

  return <Typography align="right">{currencyValue}</Typography>;
};

const TransactionDetails = ({ model }: TransactionDetailsProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  return (
    <>
      <TransactionDetailsListingTable
        title={t('transaction->>Page.SubHeader.CandidateFeePayable')}
        tableData={model.cddtPayableFeeModels}
        totalAmount={model.feePayable}
      />
      <TransactionDetailsListingTable
        title={t('transaction->>Page.SubHeader.PaymentTransactions')}
        tableData={model.paymentTransactionModels}
        totalAmount={undefined}
        isPaymentTransactionsData
      />
      {/* insert outstanding amount */}
      <Box className={classes.outstandingAmountPosition}>
        <Typography className={classes.lastUpdatedOnLabel}>
          {t('components->>Transaction.LastUpdatedOn')}
        </Typography>
        <Typography className={classes.lastUpdatedOnPosition}>
          {model?.lastUpdatedOn ?? '-'}
        </Typography>
        {/* Disable Outstanding Amount, will enable back in 2024 */}
        {/* <Typography className={classes.outstandingAmountLabel}> */}
        {/* </Typography> */}
        {/* <Typography className={classes.outstandingAmountValuePosition}> */}
        {/*  <SetTransactionAmountPrefix value={model?.outstandingAmount ?? '0.00'} /> */}
        {/* </Typography> */}
      </Box>
    </>
  );
};

export default TransactionDetails;
